import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import SalaCunaIcon from '../../../components/SvgIcon/icons/SalaCunaIcon'
import { useLoadingContext } from '../../../utils/hooks/Context/LoadingContext'
import { CheckCircleIcon } from '@chakra-ui/icons'
import { REPOSITORY } from '../../../api/repository/Repository'

export function SalaCunaAction() {
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const [isOpen, setIsOpen] = useState(false)
  const toast = useToast()

  const handleOpenModal = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.dashboard
      .SolicitudContactoSalaCuna()
      .then(() => {
        setIsOpen(true)
      })
      .catch((error) => {
        console.error('Error enviando el correo:', error)
        toast({
          title: 'Error.',
          description: 'Hubo un problema al enviar la solicitud.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      })
      .finally(() => {
        handleCLoseLoading()
      })
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Button
        onClick={handleOpenModal}
        style={{
          margin: 0,
          paddingTop: 25,
          paddingBottom: 25,
          width: 'fit-content',
          borderColor: '#40A4E0',
          backgroundColor: '#40A4E0',
          boxShadow: '3px 4px 9px 0px #00000026',
        }}
      >
        <HStack>
          <SalaCunaIcon width="30" height="30" color="#ffffff" />
          <Text style={{ color: '#FFFFFF', textAlign: 'start' }} fontSize={14}>
            CONTRATA ADMINISTRACIÓN
            <br />
            DE SALA CUNA AQUÍ
          </Text>
        </HStack>
      </Button>
      <Modal isOpen={isOpen} onClose={handleCloseModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader display="flex" alignItems="center">
            <CheckCircleIcon color="green.500" boxSize={6} />
          </ModalHeader>
          <ModalBody textAlign={'center'}>
            <b>Serás contactado por tu Ejecutiva.</b>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleCloseModal}>
              Aceptar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
